module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_mobile-8c0b138f2e0f8753b37877936daaa9c4.jpg";